define('rebrush/components/checkout/address/qaddress',[
	'jquery',
	'lodash',
	'cartware_checkout',
	'cartware/components/_base',
	'text!shoptheme/templates/magnific-popup/default.html',
	'text!shoptheme/templates/customer/address.html',
	'cartware/jquery/bem',
	'json2',
	'magnific-popup',
], function(
	$,
	_,
	Checkout,
	Component,
	PopupHtml,
	AddressHtml,
	BEM
) {
	var popupTemplate = null,
		addressTemplate = null,
		messageTemplate = null;

	return Component.create({
		$init: function() {
			this._adviseShipping();
			this._adviseBilling();
		},

		_adviseShipping: function() {
			this._setupAdvise('shipping');
		},

		_adviseBilling: function() {
			this._setupAdvise('billing');
		},

		_setupAdvise: function(type) {
			var self = this;

			Checkout().retrieve(type, function(obj) {
				var onSave = obj.onSave;
				obj.onSave = function(transport) {
					var response = JSON.parse(transport.responseText);

					if (response.error && 'qaddress' in response) {
						$.magnificPopup.open({
							items: {
								src: self._renderPopup({
									title: Translator.translate('Address validation'),
									body: self._renderTemplate({
										message: response.message,
										address: response.qaddress ? self._renderAddress(response.qaddress) : ''
									})
								}),
								type: 'inline'
							},

							callbacks: {
								open: function() {
									var self = this;
									this.content.on('click', '[data-mfp-close]', function(e) {
										self.currentTarget = e.currentTarget;
										self.close();
									});
								},

								close: function() {
									this.block = BEM.block('qaddress-validation-result');
									let $currentTarget = this.currentTarget ? $(this.currentTarget) : this.block;
									let acceptButtonClicked = $currentTarget.hasClass('popup-correct-address-trigger');

									// If accept button was clicked, write the response address
									if (acceptButtonClicked) {
										self._writeAddress(type, response.qaddress);
										if (type === 'shipping') {
											shipping.save();
										}
										else if (type === 'billing') {
											billing.save();
										}
									}
								}
							}
						});

						return;
					}

					return onSave.apply(this, arguments);
				};
			});
		},

		_writeAddress: function(type, address) {
			_.forEach(address, function(value, key) {
				var node;

				if (_.isArray(value)) {
					_.forEach(value, function(val, i) {
						node = $($('[name="' + type + '[' + key + '][]"]').get(i));
						node.val(val);
					});
				} else {
					node = $('[name="' + type + '[' + key + ']"]');
					node.val(value);
				}
			});
		},

		_renderPopup: function(data) {
			if (null === popupTemplate) {
				popupTemplate = _.template(PopupHtml);
			}

			return popupTemplate(data);
		},

		_renderAddress: function(data) {
			if (null === addressTemplate) {
				addressTemplate = _.template(AddressHtml);
			}

			return addressTemplate(data);
		},

		_renderTemplate: function(data) {
			const templateId = 'qaddress-popup-template';

			// Check if the template needs to be reloaded
			if (messageTemplate === null || messageTemplate.source !== templateId) {
				const templateContent = $(`#${templateId}`).html();
				messageTemplate = _.template(templateContent);
				messageTemplate.source = templateContent;
			}

			return this._renderData(messageTemplate(data), data);
		},

		_renderData: function(templateHtml, data) {
			let $popupContainer = $(templateHtml);
			$popupContainer.find('.message-container').html(data.message);

			// Check if the address is provided
			if (data.address) {
				$popupContainer.find('.address-container').html(data.address);
			} else {
				$popupContainer.find('.address-buttons')
					.css({'border-top': 'none', 'padding-top': '0'});
			}
			return $('<div />').append($popupContainer.clone()).html();
		}
	});
});
